import React, { useState } from 'react';
import { BuildingIcon, CalendarDaysIcon, CalendarIcon, ClipboardListIcon, DatabaseIcon, FileSpreadsheetIcon, GraduationCapIcon, MailIcon, MegaphoneIcon, MessageCircleIcon, SendIcon, WebhookIcon, WorkflowIcon, ZapIcon } from 'lucide-react';
import { listIntegrations } from '../../services/integrationService';
import { PageHeader } from '../../components/crm/PageHeader';
import { Button } from '../../components/ui/Button';
import { Modal } from '../../components/ui/Modal';
import { Tag } from '../../components/ui/Tag';
const ICONS: Record<string, React.ComponentType<{
  className?: string;
}>> = {
  Database: DatabaseIcon,
  Megaphone: MegaphoneIcon,
  MessageCircle: MessageCircleIcon,
  CalendarDays: CalendarDaysIcon,
  GraduationCap: GraduationCapIcon,
  ClipboardList: ClipboardListIcon,
  FileSpreadsheet: FileSpreadsheetIcon,
  Webhook: WebhookIcon,
  Mail: MailIcon,
  Calendar: CalendarIcon,
  Zap: ZapIcon,
  Workflow: WorkflowIcon,
  Send: SendIcon
};
export function Integrations() {
  const integrations = listIntegrations();
  const [selected, setSelected] = useState<string | null>(null);
  const current = integrations.find(i => i.id === selected);
  return <>
      <PageHeader title="Integraciones" description="Conecta AVA con las herramientas que ya usa tu empresa." data-id="element-823" data-mp="2o8hgbh6hc7ca" />

      <ul className="grid gap-4 sm:grid-cols-2 xl:grid-cols-3" data-id="element-824" data-mp="2jd204il01zcp">
        {integrations.map(integration => {
        const Icon = ICONS[integration.icon] ?? BuildingIcon;
        const soon = integration.status === 'proximamente';
        return <li key={integration.id} className="flex flex-col rounded-lg border border-border bg-background p-5 shadow-sm" data-id="element-825" data-mp="25k2mkm4s2f7s">
              <div className="flex items-start gap-3" data-id="element-826" data-mp="1vkv81vmb4ej3">
                <span className="flex h-10 w-10 flex-none items-center justify-center rounded-md bg-primary/10" data-id="element-827" data-mp="1vkbpccou1m40">
                  <Icon className="h-5 w-5 text-primary" data-id="element-828" data-mp="1rlvwhs62ljio" />
                </span>
                <div className="min-w-0" data-id="element-829" data-mp="1gx39uzohqum8">
                  <h2 className="text-sm font-semibold text-foreground" data-id="element-830" data-mp="1lx9a348ttpfx">
                    {integration.name}
                  </h2>
                  <p className="mt-1 text-sm text-muted-foreground" data-id="element-831" data-mp="17z1eaznj0u6c">
                    {integration.description}
                  </p>
                </div>
              </div>
              <div className="mt-5 flex items-center justify-between border-t border-border pt-4" data-id="element-832" data-mp="20m5cako7c88m">
                <Tag data-id="element-833" data-mp="24o8pbdqirkw0">{soon ? 'Próximamente' : 'No conectado'}</Tag>
                <Button size="sm" variant={soon ? 'ghost' : 'secondary'} disabled={soon} onClick={() => setSelected(integration.id)} data-id="element-834" data-mp="1qwlt1dwkucd8">
                  Conectar
                </Button>
              </div>
            </li>;
      })}
      </ul>

      <Modal open={Boolean(current)} onClose={() => setSelected(null)} title={current ? `Conectar ${current.name}` : ''} footer={<div className="flex justify-end" data-id="element-836" data-mp="2tp6ih3vr0qp0">
            <Button variant="secondary" onClick={() => setSelected(null)} data-id="element-837" data-mp="2toew8jo1k5be">
              Entendido
            </Button>
          </div>} data-id="element-835" data-mp="2od1bw3ywg7qf">
        <p className="text-sm text-muted-foreground" data-id="element-838" data-mp="32hi2o809rhwj">
          La conexión con {current?.name} se activará cuando el sistema esté
          conectado a Supabase y se configuren las credenciales correspondientes.
          Ninguna clave se guarda en el navegador.
        </p>
      </Modal>
    </>;
}